const MockData = {
  "people": [
    {
      "id": 1,
      "active": true,
      "type": "מועמד",
      "name": "שלו גרדוס",
      "organisation": "Google",
      "job": "מפתח",
      "gender": "זכר",
      "tribe": "חילוני",
      "city": "Tel-Aviv",
      "sector": "מגזר עסקי",
      "phone": "054-219-7723"
    },
    {
      "id": 2,
      "active": true,
      "type": "מועמד",
      "evaluatorType": "מעוז",
      "name": "דין ארבוב",
      "organisation": "Moovit",
      "job": "מנהל מוצר",
      "gender": "זכר",
      "tribe": "דתי",
      "city": "Tel-Aviv",
      "sector": "מגזר חברתי",
      "phone": "054-219-7723"
    }
  ],
  "evaluaters": [
    {
      "id": 1,
      "active": true,
      "type": "מועמד",
      "name": "ניצן ברקן",
      "organisation": "Google",
      "job": "מפתחת",
      "gender": "נקבה",
      "tribe": "חילוני",
      "sector": "מגזר עסקי",
      "phone": "054-219-7723"
    },
    {
      "id": 2,
      "active": true,
      "type": "מועמד",
      "evaluatorType": "מעוז",
      "name": "רוי דחבש",
      "organisation": "PayPal",
      "job": "מפתחת",
      "gender": "זכר",
      "tribe": "דתי",
      "sector": "מגזר ממשלתי",
      "phone": "054-219-7723"
    }
  ],
  "notes": [
    {
      "person": 1,
      "note": "This is my note"
    }
  ]
};

export default MockData;